import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["name"];
/**
 * A type to be compatible with the versions of messages that have been used
 * in Nova's development. Some of these types may be deprecated in the future.
 *
 * Prefer to use MessageBundle where possible.
 */

/**
 * A type representing locally built message bundles.
 */

export function isMessageBundle(mb) {
  return !!mb.messages;
}
export function toMessageBundle(bundle) {
  if (isMessageBundle(bundle)) {
    return bundle;
  }
  const {
      name = ''
    } = bundle,
    messages = _objectWithoutProperties(bundle, _excluded);
  return {
    name,
    comments: [],
    messages
  };
}
//# sourceMappingURL=MessageBundle.js.map